import {
  InputArray,
  type TFormMethods,
  useFieldArray,
} from "@fluidattacks/design";
import { useEffect } from "react";

import type { IFormValues } from "features/add-oauth-root-form/types";

const InputArrayGitignore = ({
  control,
  name,
  placeholder,
  addText,
}: {
  control: TFormMethods<IFormValues>["control"];
  name: string;
  placeholder: string;
  addText: string;
}): JSX.Element => {
  const { fields, append, remove } = useFieldArray({
    control,
    name: name as "gitignore",
  });

  useEffect((): void => {
    if (fields.length === 0) {
      append({ paths: [""] });
    }
  }, [fields, append]);

  return (
    <InputArray
      addText={addText}
      append={append}
      control={control}
      fields={fields}
      name={name}
      placeholder={placeholder}
      remove={remove}
    />
  );
};

export { InputArrayGitignore };
